var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.68902 4.86741L0.128743 1.20066C-0.0429142 1.02388 -0.0429142 0.737101 0.128743 0.560319L0.544054 0.132609C0.715527 -0.0439835 0.993256 -0.0441718 1.1651 0.131855L3.99991 3.0379L6.8349 0.132043C7.00674 -0.0441722 7.28447 -0.0437945 7.45595 0.132798L7.87126 0.560508C8.04291 0.73729 8.04291 1.02406 7.87126 1.20085L4.3108 4.86741C4.13914 5.0442 3.86068 5.0442 3.68902 4.86741Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.bccd373debb1c948018c46c5c332144f.svg";
export { ForwardRef as ReactComponent };